import React from "react";

import { Trans } from "@lingui/react/macro";

import Typography from "@mui/material/Typography";

import LogomarkWithGradient from "@readai/common/components/LogomarkWithGradient";
import { Row } from "@readai/pulse/components/Stack";

const ReadSmartSchedulerLogo = () => {
  return (
    <Row variant="left" spacing={1}>
      <LogomarkWithGradient
        sx={{ height: "24px", width: "24px", padding: "4px" }}
      />
      <Typography variant="bodyPrimaryMed">
        <Trans>Read Smart Scheduler</Trans>
      </Typography>
    </Row>
  );
};

export default ReadSmartSchedulerLogo;
